export default __webpack_public_path__ + "static/media/firebase.53261474.svg";